import ObjectsList from "../views/ObjectsList"
import ObjectsDetail from "../views/ObjectsDetail"

export default [
	{
		path: "/:tenantId/objects",
		component: ObjectsList,
		name: "ObjectsList",
		meta: { featureId: "objects" },
		props: true
	},
	{
		path: "/:tenantId/objects/detail/:id",
		component: ObjectsDetail,
		name: "ObjectsDetail",
		meta: { featureId: "objects" },
		props: true
	}
]
